import $ from "jquery";

export default function Datalayer(container, postback) {
    if (container.classList.contains("js-datalayer-faq")) {
        if (container.querySelector(".popup") !== null) {
            let email = container.querySelector(".js-faqemail");
            let question = container.querySelector(".js-faqquestion");
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "faq_submit",
                email: email.value,
                question: question.value,
            });
        }
    }

    if (container.classList.contains("js-datalayer-video")) {
        let videoState = "play";
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "video",
            video_action_type: videoState,
        });

        const sendDataLayer = (e) => {
            if (!e.target.classList.contains("banner__text")) {
                videoState = videoState == "play" ? "stop" : "play";
                window.dataLayer.push({
                    event: "video",
                    video_action_type: videoState,
                });
            }
        };

        window.addEventListener("blur", function () {
            if (document.activeElement == container.querySelector("iframe")) {
                videoState = videoState == "play" ? "stop" : "play";
                window.dataLayer.push({
                    event: "video",
                    video_action_type: videoState,
                });
            }
        });
    }

    $(".js-eshoplink").click(function (e) {
        e.preventDefault();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "exit_to_eshop",
            exit_to_eshop_url: $(this).attr("href"),
        });
        if ($(this).attr("target") == "_blank") {
            window.open($(this).attr("href"));
        } else {
            window.location.href = $(this).attr("href");
        }
    });
}

export function datalayerQuizStart() {
    window.dataLayer.push({
        event: "quiz_start",
    });
}

export function datalayerQuizQuestion(question) {
    window.dataLayer.push({
        event: "quiz_question",
        quiz_question: question,
    });
}

export function datalayerQuizEnd(result) {
    window.dataLayer.push({
        event: "quiz_finish",
        quiz_result: `${result}`,
    });
}
